/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProvisioningDeviceResponse
 */
export interface ProvisioningDeviceResponse {
    /**
     * 
     * @type {string}
     * @memberof ProvisioningDeviceResponse
     */
    macAddress: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProvisioningDeviceResponse
     */
    deviceId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProvisioningDeviceResponse
     */
    deviceTypeId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProvisioningDeviceResponse
     */
    stbGroupId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProvisioningDeviceResponse
     */
    groupId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProvisioningDeviceResponse
     */
    provisionedAt: Date | null;
}

export function ProvisioningDeviceResponseFromJSON(json: any): ProvisioningDeviceResponse {
    return ProvisioningDeviceResponseFromJSONTyped(json, false);
}

export function ProvisioningDeviceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProvisioningDeviceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'macAddress': json['macAddress'],
        'deviceId': json['deviceId'],
        'deviceTypeId': json['deviceTypeId'],
        'stbGroupId': json['stbGroupId'],
        'groupId': json['groupId'],
        'provisionedAt': (json['provisionedAt'] === null ? null : new Date(json['provisionedAt'])),
    };
}

export function ProvisioningDeviceResponseToJSON(value?: ProvisioningDeviceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'macAddress': value.macAddress,
        'deviceId': value.deviceId,
        'deviceTypeId': value.deviceTypeId,
        'stbGroupId': value.stbGroupId,
        'groupId': value.groupId,
        'provisionedAt': (value.provisionedAt === null ? null : value.provisionedAt.toISOString()),
    };
}

